import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
gsap.config({
  autoSleep: 60,
  force3D: true,
  nullTargetWarn: false,
  trialWarn: false,
  units: {
    left: "%",
    top: "%",
    rotation: "rad",
  },
});

export class ServiceSection {
  constructor(el) {
    this.el = el;
    this.title = el.querySelector("[data-section-title]");
    this.subTitle = el.querySelector("[data-section-sub-title]");
    this.content = el.querySelectorAll("[data-section-content]");
    this.cards = el.querySelectorAll("[data-card-item]");
    this.timeline = null;
  }

  Reset() {
    this.cards = this.el.querySelectorAll("[data-card-item]");
    gsap.set(this.title, { opacity: 0, filter: "blur(10px)" });
    gsap.set(this.subTitle, { opacity: 0 });
    gsap.set(this.content, { opacity: 0, y: 5 });
    gsap.set(this.cards, { opacity: 0, y: 5, filter: "blur(10px)" });
    this.timeline != null ? this.timeline.kill() : "";
  }

  Setup() {
    this.timeline != null ? this.timeline.kill() : "";
    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
        start: window.innerWidth < 768 ? "top bottom" : "top 70%",
        toggleActions: "restart play play reverse",
        invalidateOnRefresh: true,
      },
    });

    this.timeline.to(
      this.title,
      {
        opacity: 1,
        filter: "blur(0px)",
      },
      "header"
    );
    this.timeline.to(
      this.subTitle,
      {
        opacity: 1,
        delay: 0.1,
      },
      "header"
    );
    this.timeline.to(
      this.content,
      {
        opacity: 1,
        y: 0,
        delay: 0.2,
      },
      "header"
    );
    this.timeline.to(
      this.cards,
      {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        delay: 0.3,
        stagger: 0.1,
      },
      "header"
    );
  }
}
